import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Select, message, Input, Spin } from 'antd';
import { CASE_TYPE } from '../../config'

const windowHeight = window.innerHeight || document.body.clientHeight;
message.config({
  top: windowHeight / 2,
});
const { Option } = Select;
const { TextArea } = Input;
const DEFAULT_CASE = {
  typeId: '',
  statusId: '',
  relatedList: [],
  plaintiffList: [],
  defendantList: [],
  consultationContent: '',
  consultationNote: ''
}

class ConsultationCaseComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      caseDetail: DEFAULT_CASE
    };
  }
  componentDidMount() {
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isPutting === true && this.props.isPutting === false) {
      if (this.props.errMsg === null) {
        message.success('更新成功');
        this.props.onChangeDetail();
        this.onToggleEditMode(false);
      } else {
        message.error(this.props.errMsg);
      }
    }
    if (prevProps.consultationId !== this.props.consultationId && this.state.editMode === true) {
      this.onToggleEditMode(false);
    }
  }
  onChangeState(key, value) {
    this.setState({ [`${key}`]: value })
  }
  onToggleEditMode(editMode) {
    if (editMode === true) {
      this.setState({ 
        editMode, 
        caseDetail: this.props.caseDetail.toJS()
      });
    } else {
      this.setState({ editMode });
    }
    this.props.onChangeIsEditing(editMode);
  }
  onChangeCase(key, value) {
    let { caseDetail } = this.state;
    caseDetail = JSON.parse(JSON.stringify(caseDetail));
    caseDetail[key] = value;
    this.setState({ caseDetail })
  }
  onSubmitCase() {
    const { caseDetail } = this.state;
    this.props.onUpdateCase(
      this.props.consultationId, 
      caseDetail.typeId, 
      caseDetail.statusId, 
      caseDetail.relatedList, 
      caseDetail.plaintiffList,
      caseDetail.defendantList,
      caseDetail.consultationContent,
      caseDetail.consultationNote
    );
  }
  render() {
    const { editMode, caseDetail } = this.state;
    if (!this.props.caseDetail || this.props.caseDetail.size === 0) {
      return null;
    }
    return (
      <div className="consultationcase-section section-col-item">
        {
          editMode
          ?
            <form onSubmit={e => {e.preventDefault();this.onSubmitCase()}}>
              <div className="col-item-tool">
                <button className="btn-cancel" type="button" onClick={e => this.onToggleEditMode(false)}>取消</button>
                <button className="btn-update" type="submit" disabled={this.props.isPutting}>更新</button>
              </div>
              <div className="col-item-group">
                <div className="col-item">
                  <div className="col-title required">案件種類：</div>
                  <Select className="col-edit"
                    size="small"
                    showSearch
                    value={caseDetail.typeId}
                    onChange={value => this.onChangeCase('typeId', value)}
                  >
                    {
                      CASE_TYPE.map(caseType =>
                        <Option key={`casetypeedit-${caseType.id}`} value={caseType.id}>{caseType.name}</Option>
                      )
                    }
                  </Select>
                </div>
                {
                  caseDetail.typeId !== 6
                  &&
                  <>
                    <div className="col-item">
                      <div className="col-title">
                        { CASE_TYPE.find(type => type['id'] === caseDetail.typeId).plaintiff }：
                      </div>
                      <div className="col-text">
                        <Select className="col-edit"
                          size="small"
                          mode="tags"
                          dropdownStyle={{ display: 'none' }}
                          value={caseDetail.plaintiffList}
                          onChange={value => this.onChangeCase('plaintiffList', value)}
                          tokenSeparators={[',']}>
                        </Select>
                      </div>
                    </div>
                    <div className="col-item">
                      <div className="col-title">
                        { CASE_TYPE.find(type => type['id'] === caseDetail.typeId).defendant }：
                      </div>
                      <div className="col-text">
                        <Select className="col-edit"
                          size="small"
                          mode="tags"
                          dropdownStyle={{ display: 'none' }}
                          value={caseDetail.defendantList}
                          onChange={value => this.onChangeCase('defendantList', value)}
                          tokenSeparators={[',']}>
                        </Select>
                      </div>
                    </div>
                  </>
                }
                <div className="col-item">
                  <div className="col-title">案件相關：</div>
                  <Select className="col-edit"
                    size="small"
                    placeholder="請輸入關鍵字。例：損害賠償"
                    mode="multiple"
                    value={caseDetail.relatedList}
                    notFoundContent={this.props.isGettingCaseRelated ? <Spin size="small" /> : '無相關資料'}
                    filterOption={false}
                    onSearch={value => this.props.onLoadRelatedList(value, 10)}
                    onChange={value => this.onChangeCase('relatedList', value)}
                  >
                    {
                      this.props.caseRelateList && this.props.caseRelateList.map(relate =>
                        <Option key={`caserelated-${relate}`} value={relate}>{`${relate}`}</Option>
                      )
                    }
                  </Select>
                </div>
                <div className="col-item">
                  <div className="col-title">諮詢內容：</div>
                  <TextArea className="col-edit"
                    rows="3"
                    size="small"
                    type="text"
                    value={caseDetail.consultationContent}
                    onChange={e => this.onChangeCase('consultationContent', e.target.value)}
                  />
                </div>
                <div className="col-item">
                  <div className="col-title">備註：</div>
                  <TextArea className="col-edit"
                    rows="3"
                    size="small"
                    type="text"
                    value={caseDetail.consultationNote}
                    onChange={e => this.onChangeCase('consultationNote', e.target.value)}
                  />
                </div>
              </div>
            </form>
          :
            <>
              <div className="col-item-tool">
                <button className="btn-edit" onClick={e => this.onToggleEditMode(true)}>編輯</button>
              </div>
              <div className="col-item-group">
                <div className="col-item">
                  <div className="col-title">案件種類：</div>
                  <div className="col-text">
                    { 
                      CASE_TYPE.find(ct => ct.id === this.props.caseDetail.getIn(['typeId'])).name
                    }
                  </div>
                </div>
                {
                  this.props.caseDetail.getIn(['typeId']) !== 6
                  &&
                  <>
                    <div className="col-item">
                      <div className="col-title">{ CASE_TYPE.find(ct => ct.id === this.props.caseDetail.getIn(['typeId'])).plaintiff }：</div>
                      <div className="col-text">
                        {
                          this.props.caseDetail.getIn(['plaintiffList']).map(plaintiff =>
                            <span key={`plaintiff-${plaintiff}`}>{ plaintiff }</span>
                          )
                        }
                      </div>
                    </div>
                    <div className="col-item">
                      <div className="col-title">{ CASE_TYPE.find(ct => ct.id === this.props.caseDetail.getIn(['typeId'])).defendant }：</div>
                      <div className="col-text">
                        {
                          this.props.caseDetail.getIn(['defendantList']).map(defendant =>
                            <span key={`defendant-${defendant}`}>{ defendant }</span>
                          )
                        }
                      </div>
                    </div>
                  </>
                }
                <div className="col-item">
                  <div className="col-title">案件相關：</div>
                  <div className="col-text">
                    {
                      this.props.caseDetail.getIn(['relatedList']).map(related =>
                        <span key={`related-${related}`}>{ related }</span>
                      )
                    }
                  </div>
                </div>
                <div className="col-item">
                  <div className="col-title">諮詢內容：</div>
                  <div className="col-text">
                    {
                      this.props.caseDetail.getIn(['consultationContent'])
                    }
                  </div>
                </div>
                <div className="col-item">
                  <div className="col-title">備註：</div>
                  <div className="col-text">
                    {
                      this.props.caseDetail.getIn(['consultationNote'])
                    }
                  </div>
                </div>
              </div>
            </>
        }
      </div>
    )
  }
}
export default withRouter(ConsultationCaseComponent);